const {
  VITE_NODE_ENV,
  VITE_BASE_URL,
  VITE_FEISHU_APP_ID,
  VITE_APP_TARGET,
  VITE_RESOLVE_BRIDGE_URL,
  VITE_DESKTOP_LOGIN_BASE_URL,
  VITE_TRPC_TEST_AUTH_TOKEN,
} = import.meta.env

export const env = {
  VITE_NODE_ENV,
  VITE_BASE_URL,
  // 飞书网页应用 App ID（cli_xxx），用于客户端内免登取 code；须与后端 FEISHU_APP_ID 同一应用。
  VITE_FEISHU_APP_ID,
  // 构建目标：website（浏览器）/ electron（桌面端渲染进程）。未注入时默认 website；
  // Electron 构建流程接入时需显式注入 'electron'（见包根 README.md“运行时目标”）。
  VITE_APP_TARGET: (VITE_APP_TARGET as 'website' | 'electron' | undefined) ?? 'website',
  VITE_RESOLVE_BRIDGE_URL,
  // 仅 electron 目标使用：外部系统浏览器打开飞书登录的绝对基址（含 /api 前缀，如 http://host:5302/api）。
  // shell.openExternal 不接受相对路径，故必须绝对；host 须与后端 FEISHU_OAUTH_REDIRECT_URI 一致，
  // OAuth 完成后浏览器才会落回带深链接中转逻辑的 website 落地页。
  VITE_DESKTOP_LOGIN_BASE_URL,
  // 仅 development 使用：非空时以该值作为 tRPC 测试 bearer token；须与 server TRPC_TEST_AUTH_TOKEN 一致。
  VITE_TRPC_TEST_AUTH_TOKEN,
}
